import Dexie from 'dexie'
import axios from 'axios'

const db = new Dexie('ImageDatabaseV2');

db.version(1).stores({
    images: '++id,[url+size],blob'
});

if (!window.OffscreenCanvas) {
    const convertToBlob = function (options) {
        return new Promise(resolve => {
            this.toBlob(function (blob) {
                return resolve(blob)
            }, options ? options.type : undefined, options ? options.quality : undefined)
        })
    }
    window.OffscreenCanvas = function (width, height) {
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        canvas.convertToBlob = convertToBlob
        return canvas
    }
}

const cache = {}

const utilsFunction = {
    getImage: url => {
        return new Promise(async (resolve, reject) => {
            try {
                const img = new Image()
                img.crossOrigin = 'anonymous'
                img.onload = () => {
                    return resolve(img)
                }
                img.onerror = (e) => {
                    return reject(e)
                }
                img.src = url
            } catch(e) {
                return reject(e)
            }
        })
    },
    getUrls: (url, size) => {
        return new Promise(async (resolve, reject) => {
            const originalUrl = url
            let resizeBlob = null;
            if (await db.images.where({ url, size }).count() > 0) {
                resizeBlob = await db.images.where({ url, size }).toArray()
                resizeBlob = resizeBlob[0].blob
            } else {
                // const originalImage = await utilsFunction.getImage(url)
                let response
                try {
                    response = await axios.get(`${url}?width=${size}&quality=75`, {responseType: 'blob'})
                } catch(e) {
                    return reject(e)
                }
                resizeBlob =  response.data // utilsFunction.sizeDown(originalImage, size)
                db.images.add({ url, size, blob: resizeBlob })
            }
            let resizeUrl
            try {
                resizeUrl = URL.createObjectURL(resizeBlob)
            } catch(e) {
                let response
                try {
                    response = await axios.get(`${url}?width=${size}&quality=75`, {responseType: 'blob'})
                } catch(e) {
                    return reject(e)
                }
                resizeBlob =  response.data
                resizeUrl = URL.createObjectURL(resizeBlob)
            }
            resolve({
                originalUrl,
                resizeUrl
            })
        })
    },
    sizeDown: (img, target = 600) => {
        return new Promise(resolve => {
            const largest = Math.max(img.width, img.height)
            const ratio = largest / target
            const canvas = new OffscreenCanvas(img.width / ratio, img.height / ratio)
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
            canvas.convertToBlob().then(resolve)
        })
    },
    isTouchDevice: () => {
        return ("ontouchstart" in document.documentElement);
    }
}

const utils = (url, size = 500) => {
    return new Promise(async resolve => {
        if (cache[url]) {
            resolve(cache[url])
            return
        }
        const urls = await utilsFunction.getUrls(url, size)
        cache[url] = urls
        resolve(urls)
    })
}

export default utils

export const { getImage, getUrls, sizeDown, isTouchDevice } = utilsFunction
